<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ tituloModal }}</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- contenido -->
        <ValidationObserver ref="form_datos">
          <v-card class="mx-auto" :loading="loading">
            <v-card-text class="text--primary px-8">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <ValidationProvider name="Empresa" rules="required">
                    <v-text-field
                      v-model="objDatos.empresa"
                      label="Empresa"
                      required
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <ValidationProvider name="Nit" rules="required">
                    <v-text-field
                      v-model="objDatos.nit"
                      type="text"
                      label="Nit"
                      required
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col v-if="this.id" cols="12" sm="6" md="6">
                  <v-autocomplete
                    v-model="objDatos.estado"
                    :items="state"
                    item-text="name"
                    item-value="val"
                    label="Estado"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </ValidationObserver>

        <!-- fin contenido -->
        <v-card-actions class="pb-8 pl-8">
          <v-btn @click="save" color="primary" dark :loading="loading">
            Guardar
          </v-btn>
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { db } from "../../firebase";
export default {
  name: "ModalVehiculos",
  data: () => ({
    objDatos: {},
    dialog: true,
    loading: true,
    state: [
      { name: "Activo", val: true },
      { name: "Inactivo", val: false },
    ],
    collection: "empresas",
  }),
  props: {
    showModal: { type: Boolean, default: false },
    id: { type: String },
  },
  computed: {
    tituloModal(props) {
      return props.id ? "ACTUALIZAR" : "AGREGAR";
    },
  },
  async created() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        if (this.id) {
          const datos = await db.collection(this.collection).doc(this.id).get();
          this.objDatos = datos.data();
        }
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
    async save() {
      try {
        const validar = await this.$refs.form_datos.validate();
        if (!validar) return false;
        this.loading = true;
        Object.entries(this.objDatos).forEach((el) => {
          if (typeof el[1] === "string") {
            this.objDatos[el[0]] = el[1].toUpperCase().trim();
          }
        });
        if (!this.id) {
          // Guardar
          this.objDatos.estado = true;
          await db.collection(this.collection).add(this.objDatos);
          this.$swal({ icon: "success", title: "Operacion Exitosa", text: "" });
          this.cerrarModal();
          this.$emit("actualizar");
        } else {
          // Actualizar
          await db
            .collection(this.collection)
            .doc(this.id)
            .update(this.objDatos);
          this.$swal({ icon: "success", title: "Operacion Exitosa", text: "" });
          this.cerrarModal();
          this.$emit("actualizar");
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.handleError(error);
      }
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
      this.objDatos = {};
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>
